export default "__VITE_ASSET__CXF$e6kr__"